import React from 'react';

const ExpandDownArrow = ({ onClick }: { onClick?: () => void }) => {
  return (
    <button className="button--icon sml border-0" onClick={onClick}>
      <i className="material-symbols-outlined">arrow_drop_down</i>
    </button>
  );
};

export default ExpandDownArrow;
